<template>
    <div>
      <div class="card mb-3">
          <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
              <div class="card-body">
                <div>
                  <h6 class="heading-small text-muted mb-4">Search</h6>
                  <base-input alternative="" label="Deployment Date"><br>
                    <a-range-picker v-model="dateRange"
                                    format="MM-DD-YYYY"
                                    :placeholder="['Start Date', 'End Date']"
                                    style="width:100%"/>
                  </base-input>
                </div>
                <div>
                  <base-input alternative="" label="OS"><br>
                  <a-select showSearch
                            v-model="selectedOS"
                            placeholder="Select OS"
                            optionFilterProp="children"
                            style="width: 100%">
                    <a-select-option v-for="option in OsOptions"
                                    :key="option.key"
                                    :value="option.key">
                      {{option.value}}
                    </a-select-option>
                  </a-select>
                  </base-input>
                </div>
                <div>
                  <base-input alternative="" label="Type"><br>
                  <a-select showSearch
                            v-model="selectedType"
                            placeholder="Select Type"
                            optionFilterProp="children"
                            style="width: 100%">
                    <a-select-option v-for="option in OsTypes"
                                    :key="option.key"
                                    :value="option.key">
                      {{option.value}}
                    </a-select-option>
                  </a-select>
                  </base-input>
                </div>
                <div>
                  <button class="float-right btn btn-sm btn-success mr-2" @click="retrieveDeveloperAccounts(1, ''); filterTag = 1"> <span class="fa fa-filter" /> Filter </button>
                </div>
                <br/>
                <hr class="my-4" />
                  <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                  <div>
                      <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                          All
                      </base-radio>
                      <base-radio name="D" class="mb-3" v-model="filterStatus" value="D">
                          Deployed
                      </base-radio>
                      <base-radio name="F" class="mb-3" v-model="filterStatus" value="F">
                          For Deployment
                      </base-radio>
                      <base-radio name="P" class="mb-3" v-model="filterStatus" value="P">
                          Pending
                      </base-radio>
                  </div>
              </div>
            </div>
            <div class="col-md-9" >
              <div class="card-body">
                  <div class="ml-2"><h2 class="card-title">POS Versions</h2></div>
                  <a-table :scroll="{ x: 1000 }" size="small" rowKey="id" :columns="columns" :data-source="data" style="min-height: 50vh; overflow: auto;">
                      <span slot="os" slot-scope="text, record">
                          <div v-if="record.os == 'W'">WINDOWS</div>
                          <div v-if="record.os == 'L'">LINUX</div>
                          <div v-if="record.os == 'M'">MAC</div>
                      </span>
                      <span slot="update_type" slot-scope="text, record">
                          <div v-if="record.update_type == 'H'">HOTFIX</div>
                          <div v-if="record.update_type == 'S'">SCHEDULED</div>
                      </span>
                      <span slot="version" slot-scope="text, record">
                          <a-tag v-if="record.status == 'D'" color="green">{{record.version}}</a-tag>
                          <a-tag v-if="record.status == 'P'" color="red">{{record.version}}</a-tag>
                          <a-tag v-if="record.status == 'F'" color="blue">{{record.version}}</a-tag>
                      </span>
                      <span slot="status" slot-scope="text, record">
                          <a-tag v-if="record.status == 'D'" color="green">Deployed</a-tag>
                          <a-tag v-if="record.status == 'P'" color="red">Pending</a-tag>
                          <a-tag v-if="record.status == 'F'" color="blue">For Deployment</a-tag>
                      </span>
                      <span slot="action" slot-scope="text, record">
                        <center>
                          <a-dropdown>
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                              <i class="fa fa-ellipsis-v"></i>
                            </a>
                            <a-menu slot="overlay">
                              <template>
                                <a-menu-item>
                                  <button class="btn btn-info btn-sm" @click.prevent="$emit('changePosRelease', record.id + '|V')">
                                    &nbsp;&nbsp;View&nbsp;&nbsp;
                                  </button>
                                </a-menu-item>
                                <a-menu-item v-if="['F', 'P'].includes(record.status)">
                                  <button class="btn btn-warning btn-sm" @click.prevent="$emit('changePosRelease', record.id + '|U')">
                                    &nbsp;&nbsp;Edit&nbsp;&nbsp;
                                  </button>
                                </a-menu-item>
                                <a-menu-item v-if="['F', 'P'].includes(record.status)">
                                  <button class="btn btn-success btn-sm">
                                    <a-popconfirm
                                        :title="'You are about to deploy POS version' + record.version + '?'"
                                        @confirm="deployPosUpdate(record.id)"
                                        okText="Deploy"
                                        cancelText="Cancel"
                                        >Deploy</a-popconfirm
                                    >
                                  </button>
                                </a-menu-item>
                                <a-menu-item v-if="record.status.includes('D')">
                                  <button class="btn btn-success btn-sm" @click.prevent="openDrawerStats(record.id)">
                                    Stats
                                  </button>
                                </a-menu-item>
                              </template>
                            </a-menu>
                          </a-dropdown>
                        </center>
                      </span>
                      <span slot="deployed_at" slot-scope="text, record">
                          {{deployAt(record.deployed_at)}}
                      </span>
                  </a-table>
              </div>
            </div>
          </div>
      </div>
      <a-drawer v-if="drawerVisibleStats" title="" :width="480" placement="right" @close="onCloseStats" :visible="drawerVisibleStats">
        <div>
                <h6 class="heading-small text-muted pb-3">POS version deployment statistics</h6>
                
        </div>
      </a-drawer>
    </div>

</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'
import moment from 'moment';

const columns = [
  {
    title: '',
    scopedSlots: { customRender: 'action' },
    fixed: "left",
    align: "center",
  },
  {
    title: 'OS',
    dataIndex: 'os',
    fixed: 'left',
    scopedSlots: { customRender: 'os' },
  },
  {
    title: 'Version',
    dataIndex: 'version',
    scopedSlots: { customRender: 'version' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Type',
    dataIndex: 'update_type',
    ellipsis: true,
    scopedSlots: { customRender: 'update_type' },
  },
  {
    title: 'Deployed At',
    dataIndex: 'deployed_at',
    ellipsis: true,
    scopedSlots: { customRender: 'deployed_at' },
  },
  {
    title: 'Statistics',
    dataIndex: 'statistics',
    ellipsis: true,
  },
  
];

export default {
  mounted: async function(){  
    
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
  },
  watch: {
    filterStatus: function() {
      this.retrieveDeveloperAccounts(null, this.filterStatus)
      this.filterText = ''
    }
  },
  data () {
    return {
        drawerVisibleStats: false,
        filterTag: 0,
        selectedOS: 'A',
        selectedType: 'A',
        dateRange: [moment().startOf('day'), moment().endOf('day')],
        selectedProfile: "pos_releases",
        columns,
        data: [],
        userCode: secureStorage.getItem("userCode"),
        filterStatus: '0',
        searchFilter: "name",
        placeholder: "Search by name",
        filterText: '',
        OsOptions : [
            {key: 'A', value: 'All'},
            {key: 'W', value: 'Windows'},
            {key: 'L', value: 'Linux'},
            {key: 'M', value: 'Mac'}
        ],
        OsTypes : [
            {key: 'A', value: 'All'},
            {key: 'H', value: 'Hotfix'},
            {key: 'S', value: 'Scheduled'}
        ],
    }
  },
  mounted: async function(){
    this.retrieveDeveloperAccounts()
  },
  methods: {
    onCloseStats(){
       this.drawerVisibleStats = false
    },
    openDrawerStats(id){
       this.drawerVisibleStats = true
    },
    deployAt(deployed_at) {
         return moment(deployed_at).format('MMMM DD, YYYY')
    },
    async deployPosUpdate(id){
      var posRelease = await HTTPRequest.postRequest(this.endPoint + 'pos_releases/update_pos_update?id=' + id , null, null)
      if(posRelease.error == undefined){
          this.$notification['success']({
          message: 'Deployment Success',
          description: "POS version has been deployed accordingly. "
          });
          this.posRelease  = posRelease
          if(this.filterTag == 1)
            this.retrieveDeveloperAccounts(1, '');
          else
            this.retrieveDeveloperAccounts();
      } else {
          this.$notification['error']({
          message: 'Deployment Error',
          description: posRelease.error
          });
      }
    },
    filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async retrieveDeveloperAccounts(search, status){
      if (search == null && (status == null || status == '0')) {
        var pos_releases = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_pos_releases', null)
        if (pos_releases) this.data = pos_releases['data']
      } else if (search == 1 || search != 1) {
        let filters = ``;
        filters += `os=${this.selectedOS}`;
        filters += `&update_type=${this.selectedType}`;
        filters += `&status=${this.filterStatus}`;
        filters += `&from=${this.dateRange[0].format('YYYY-MM-DD')}`;
        filters += `&to=${this.dateRange[1].format('YYYY-MM-DD')}`;
        var pos_releases = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_pos_releases?'+filters, null)
        if (pos_releases) this.data = pos_releases['data']
      } else if (status != null && search != null){
        var pos_releases = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_pos_releases?name='+search+'&status='+status, null)
        if (pos_releases) this.data = pos_releases['data']
      }
    },
    notify(action){
      this.$notification['success']({
          message: 'Developer Account',
          description: "Success " + action + " account"
      });
    },
    async approve(record) {
      var developer_account_payload = {"status": "A", "approved_by": this.userCode, "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'A') {
        this.notify('approving');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    async activate(record) {
      var developer_account_payload = {"status": "A", "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'A') {
        this.notify('activating');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    async deactivate(record) {
      var developer_account_payload = {"status": "D", "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'D') {
        this.notify('deactivating');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    setCurrentProfile(profile){
      this.selectedProfile = profile
    },
    changeSearchFilter(searchFilter){
      this.searchFilter = searchFilter
      this.placeholder = "Search by " + searchFilter
    },
    doFilter(){
      this.retrieveDeveloperAccounts(this.filterText, null)
    },
  },
}
</script>

<style>
</style>


